import { gql, useQuery } from "@apollo/client";
import { HANDOVER_CARRIER_FIELDS, HandoverCarrierType } from "../../../../../graphql/types/HandoverCarrierType";

export interface HandoverCarrierFiltersInput {
  carrierName?: string | null;
  contactName?: string | null;
  status?: number | null;
  carrierType?: number | null;
}

export interface PageRequestInput {
  page: number;
  size: number;
}

export interface HandoverCarrierPageResponse {
  content: HandoverCarrierType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

interface GetHandoverCarriersResponse {
  getHandoverCarriers: HandoverCarrierPageResponse;
}

export const GET_HANDOVER_CARRIERS = gql`
  query GetHandoverCarriers($filters: HandoverCarrierFiltersInput, $pageRequest: PageRequestTypeInput) {
    getHandoverCarriers(filters: $filters, pageRequest: $pageRequest) {
      content {
        ...HandoverCarrierFields
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
  ${HANDOVER_CARRIER_FIELDS}
`;

export const useHandoverCarriers = (
  filters: HandoverCarrierFiltersInput,
  pageRequest: PageRequestInput
) => {
  const { data, loading, error, refetch } = useQuery<GetHandoverCarriersResponse>(
    GET_HANDOVER_CARRIERS,
    {
      variables: { filters, pageRequest },
      fetchPolicy: 'no-cache',
    }
  );

  return {
    pageResponse: data?.getHandoverCarriers ?? null,
    loading,
    error,
    refetch,
  };
};
